import { approvalNegativeIcon } from "@pjs/core-ui";
import { INoticeType } from "@pjs/core-ui";

export const approvalNegative: INoticeType = {
    colour: "#B40000",
    icon: approvalNegativeIcon
};
